import { ReactWebComponent } from '@app/utils/web-components';
import { lazy } from 'react';
import { parseUserRole } from './utils/parseUserRole';

const AppProviders = lazy(() => import('@app/components/AppProviders'));
const UsageLimitationBanner = lazy(() => import('./UsageLimitationBanner'));

class UsageLimitationBannerWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['team-uuid', 'user-role'];
    }

    render() {
        const teamUuid = this.prop('team-uuid');
        const rawUserRole = this.prop('user-role');

        if (!teamUuid) {
            console.error('UsageLimitationBanner: team-uuid is required');
            return null;
        }

        return (
            <AppProviders>
                <UsageLimitationBanner teamUuid={teamUuid} userRole={parseUserRole(rawUserRole)} />
            </AppProviders>
        );
    }
}

customElements.define('usage-limitation-banner', UsageLimitationBannerWebComponent);
